<ca-card *ngIf="marcasDestacadas?.length > 0">
    <div ca-card-title>{{'AUTOS.BUSCADOR_MODELOS.MARCAS.TITULO' | translate}}</div>
    <div ca-card-content>
        <div class="autos-contenedor-img ">
            <div class="row">
                <ng-container *ngFor="let marca of marcasDestacadas; let i = index">
                    <div class="col-2 autos-contenedor-imagenes">
                        <div class="row">
                            <img class="autos-busqueda-img marca-img"
                                [src]="'assets/images/marcas/' + marca.imagen"
                                [alt]="marca.nombreMarca"
                                (click)="seleccionarMarcaDestacada(marca)"
                                />
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="row col-4 mt-4">
            <ca-form-field class="form" *ngIf="marcas?.length > 0">
                <ca-label>{{'AUTOS.BUSCADOR_MODELOS.MARCAS.OTRAS_MARCAS' | translate}}</ca-label>
                <ca-select 
                    [options]="marcas"
                    keyValue="nombreMarca"
                    valueField="nombreMarca"
                    [placeholder]="'AUTOS.BUSCADOR_MODELOS.MARCAS.OTRAS_MARCAS' | translate"
                    formControlName="marca"
                    virtualScroll
                    (changeValue)="seleccionarMarca($event)"></ca-select>
            </ca-form-field>
        </div>
    </div>
</ca-card>